<template>
  <div>
    <v-sheet>
      <v-toolbar flat>
        <v-toolbar-title>Productos</v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-list>
          <v-list-item
            v-for="(item, index) in all"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-subtitle>{{ item.codigo }}</v-list-item-subtitle>
              <v-list-item-title>{{ item.nombre }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'ProductosMainComponent',
  computed: {
    ...mapGetters('Productos', ['all']),
  },
  async created () {
    await this.onEstablecerDB();
  },
  methods: {
    ...mapActions('Productos', ['onFetch']),
    ...mapMutations('Productos', ['setAll']),
    async onEstablecerDB () {
      // Verifica si los productos ya están cargados
      if (this.all?.length) return;
      try {
        const aux = this.getFromSession();
        if (aux) this.setAll(aux);
      } catch (error) {
        console.error('Error al cargar los productos:', error);
      }
    },
    getFromSession () {
      const aux = window.sessionStorage.getItem('pro');
      return aux ? JSON.parse(aux) : null;
    }
  }
}
</script>
